import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { IconButton, TextField, TextFieldProps, useTheme } from "@mui/material";
import { MouseEventHandler, useCallback, useMemo } from "react";

export type XTextFieldProps = TextFieldProps & {
  showclearicon?: boolean;
  onClearClicked?: () => void;
};
export const XTextField = ({
  showclearicon = false,
  onClearClicked,
  ...props
}: XTextFieldProps) => {
  const theme = useTheme();
  const hasValue = useMemo(() => {
    return props.value && (props.value as string).length > 0;
  }, [props.value]);

  const preventBlurEventFireWhenClickTheClearBtn: MouseEventHandler<HTMLButtonElement> =
    useCallback((e) => {
      e.preventDefault();
    }, []);
  return (
    <TextField
      {...props}
      sx={{
        ...props.sx,
        label: {
          fontSize: "0.95em",
        },
        fieldset: {
          legend: {
            fontSize: "0.80em",
          },
        },
        ".MuiInputBase-root.Mui-disabled": {
          backgroundColor: theme.palette.action.disabledBackground,
        },
      }}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <>
            {showclearicon && hasValue ? (
              <IconButton
                size="small"
                onClick={onClearClicked}
                onMouseDown={preventBlurEventFireWhenClickTheClearBtn}
              >
                <CancelOutlinedIcon
                  sx={{
                    ":hover": {
                      cursor: "pointer",
                    },
                  }}
                />
              </IconButton>
            ) : (
              <></>
            )}
            {props.InputProps?.endAdornment}
          </>
        ),
        sx: {
          ...props.InputProps?.sx,
          fontSize: theme.typography.fontSize,
          ".MuiInputBase-readOnly": {
            cursor: props.InputProps?.readOnly ? "default" : "",
            overflow: "hidden !important",
            textOverflow: "ellipsis",
          },
        },
      }}
      disabled={props.disabled}
      size="small"
      autoComplete="off"
    />
  );
};
